
import { createContext, useContext } from "react";
import { useTranslation } from "react-i18next";
import useCurrency from "../hooks/useCurrency";
import { throwContextError } from "../utils/core";


export type TranslationHelpers = {
  (id: string, options?: object): string;
  min(value: unknown): string;
  minCurr(value: number, toDecimal?: boolean): string;
  max(value: unknown): string;
  maxCurr(value: number, toDecimal?: boolean): string;
  required: string;
}

export type TranslationCtx = {
  t: TranslationHelpers;
}

const TranslationProvider = ({ children }: {children: React.ReactNode }) => {

  const { i18n } = useTranslation();
  const currency = useCurrency();

  const tr = i18n.t as unknown as TranslationHelpers;
  tr.required = i18n.t("required");
  tr.min = (value: unknown) => i18n.t("minimumIs", { min: value });
  tr.minCurr = (value: number, toDecimal?: boolean) => tr.min(currency.toCurrency(value, toDecimal));
  tr.max = (value: unknown) => i18n.t("maximumIs", { max: value });
  tr.maxCurr = (value: number, toDecimal?: boolean) => tr.max(currency.toCurrency(value, toDecimal));

  return (
    <TranslationContext.Provider value={{ t: tr }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const TranslationContext = createContext<TranslationCtx>(undefined as unknown as TranslationCtx);
export const useI18n = () => useContext(TranslationContext) ?? throwContextError("useI18n");
export default TranslationProvider;
